(() => {
  const counterSelector = '.gs-customer-counter';

  const formatNumber = (value, locale) => {
    try {
      return new Intl.NumberFormat(locale).format(Math.floor(value));
    } catch (error) {
      console.error('Home customer counter: unable to format the count.', error);
      return new Intl.NumberFormat('en-GB').format(Math.floor(value));
    }
  };

  const initialiseCounter = (section) => {
    const counter = section.querySelector('.gs-customer-counter__number');

    if (!counter || counter.dataset.initialised === 'true') {
      return;
    }

    counter.dataset.initialised = 'true';

    const target = Number(counter.dataset.target);
    const locale = counter.dataset.locale || document.documentElement.lang || 'en-GB';

    if (!Number.isFinite(target) || target < 0) {
      return;
    }

    const finishCounter = () => {
      counter.textContent = formatNumber(target, locale);
    };

    if (
      !('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      finishCounter();
      return;
    }

    counter.textContent = formatNumber(0, locale);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          const startTime = performance.now();
          const duration = 2200;

          const animate = (currentTime) => {
            const progress = Math.min((currentTime - startTime) / duration, 1);
            const easedProgress = 1 - Math.pow(1 - progress, 4);

            counter.textContent = formatNumber(target * easedProgress, locale);

            if (progress < 1) {
              window.requestAnimationFrame(animate);
              return;
            }

            finishCounter();
          };

          window.requestAnimationFrame(animate);
          observer.unobserve(section);
        });
      },
      { threshold: 0.35 }
    );

    observer.observe(section);
  };

  const initialiseCounters = (root = document) => {
    if (root instanceof Element && root.matches(counterSelector)) {
      initialiseCounter(root);
      return;
    }

    root.querySelectorAll(counterSelector).forEach(initialiseCounter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseCounters(), { once: true });
  } else {
    initialiseCounters();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseCounters(event.target);
  });
})();
